var parent = require('../../es/instance/filter');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/filter.js
// module id = 437
// module chunks = 0 1